import { optionTitle_composeSurfaceActions } from './ComposeSurfaceActionsOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ComposeSurfaceActionsOption: LazyOption = createLazyOption(
    {
        key: 'composeSurfaceActions',
        titleStringKey: optionTitle_composeSurfaceActions,
        searchTermsStringKey: optionTitle_composeSurfaceActions,
    },
    lazyFullModule,
    m => m.ComposeFullSettings
);
export default ComposeSurfaceActionsOption;
